export default "__VITE_ASSET__DnXZbNUB__"